var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 15.312,
    height: 15.215,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1675",
    "data-name": "Group 1675",
    transform: "translate(-929 -933)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 22,
    height: 22,
    transform: "translate(929 933)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1673",
    "data-name": "Group 1673",
    transform: "translate(932 936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1674",
    "data-name": "Group 1674",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M4.149,8.623v5.9a.692.692,0,0,1-.692.692H.691A.691.691,0,0,1,0,14.523v-5.9a.691.691,0,0,1,.691-.692H3.457a.692.692,0,0,1,.692.692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M9.007,0H6.241a.692.692,0,0,0-.692.692V14.523a.692.692,0,0,0,.692.692H9.007a.692.692,0,0,0,.692-.692V.692A.692.692,0,0,0,9.007,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M14.62,3.782H11.854a.692.692,0,0,0-.692.692V14.523a.692.692,0,0,0,.692.692H14.62a.692.692,0,0,0,.692-.692V4.474a.692.692,0,0,0-.692-.692"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsage);
export default __webpack_public_path__ + "static/media/icon-usage.b290f3eeb73ce1c037aa18bfd03d2eb4.svg";
export { ForwardRef as ReactComponent };